import { PositionAssetTypeEnum } from '../../../types';

/**
 * Resolves the Underlying identity for a position row.
 * Spot and Share are the underlying themselves; derivatives peel BaseCurrency.
 */
export function resolvePositionUnderlying({
  asset,
  assetType,
  securitiesBySymbol,
}: {
  asset: string | null | undefined;
  assetType: PositionAssetTypeEnum | undefined;
  securitiesBySymbol?: Map<string, { BaseCurrency?: string }> | undefined;
}): string | undefined {
  if (asset == null) {
    return undefined;
  }

  if (assetType === PositionAssetTypeEnum.Spot || assetType === PositionAssetTypeEnum.Share) {
    return asset;
  }

  return securitiesBySymbol?.get(asset)?.BaseCurrency;
}
